import React from "react";
import { useDevice } from "@draftink/draftink";
import { AIAssistant } from "./AIAssistant";
import type { DraftinkImperativeAPI } from "@draftink/draftink/types";

interface MobileAIAssistantProps {
  draftinkAPI: DraftinkImperativeAPI;
}

export const MobileAIAssistant: React.FC<MobileAIAssistantProps> = ({ draftinkAPI }) => {
  const device = useDevice();
  
  // Only render on mobile devices
  if (!device.editor.isMobile) {
    return null;
  }
  
  return <AIAssistant draftinkAPI={draftinkAPI} />;
};